/* eslint-disable no-await-in-loop */
import {
  getIncentiveOfferEligibles,
  IncentiveOfferEligibleApiItem,
} from 'modules/incentivesMarket/api/getIncentiveOfferEligibles';

const ELIGIBLES_PAGE_SIZE = 100;

export const fetchAllIncentiveOfferEligibles = async ({
  incentiveOfferId,
  societyId,
}: {
  incentiveOfferId: string;
  societyId: string;
}): Promise<IncentiveOfferEligibleApiItem[]> => {
  let page = 1;
  let totalPages = 1;
  const allItems: IncentiveOfferEligibleApiItem[] = [];

  do {
    const response = await getIncentiveOfferEligibles({
      incentiveOfferId,
      societyId,
      page,
      items: ELIGIBLES_PAGE_SIZE,
    });

    allItems.push(...(response?.data || []));
    totalPages = response?.pagination?.totalPages || 1;
    page += 1;
  } while (page <= totalPages);

  return allItems;
};
